const style = (theme) => {
  const output = {
    root: {
      position: 'relative',
      transition: 'all 0.5s ease-out',
      '& p': {
        marginBottom: 20,
      },
      '& p:last-child': {
        marginBottom: 60,
      },
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
  }

  return output
}

export default style
